"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DialogWrapper_1 = tslib_1.__importDefault(require("./DialogWrapper"));
/**
 * @deprecated use {@link DialogManager} and {@link DialogContent} instead
 */
class RemoteDialogControllerImpl {
    constructor(handler, uncaughtExceptionHandler) {
        this.handler = handler;
        this.uncaughtExceptionHandler = uncaughtExceptionHandler;
        // Intentionally left empty
    }
    replaceWidgets(remoteDialog) {
        let dialog = new DialogWrapper_1.default(remoteDialog);
        try {
            this.handler.replaceWidgets(dialog);
        }
        catch (error) {
            if (!this.uncaughtExceptionHandler || !this.uncaughtExceptionHandler(error)) {
                throw error;
            }
        }
    }
}
exports.default = RemoteDialogControllerImpl;
//# sourceMappingURL=RemoteDialogControllerImpl.js.map